// Тексты контентных страниц: «Как это работает», шаблоны, «О сервисе».
//
// Лежат они данными (content/pages.json) и читаются с двух сторон: здесь —
// чтобы нарисовать живую страницу, и на сервере (server/content.mjs) — чтобы
// тот же текст пришёл роботу прямо в ответе. Приложение — SPA, и без этого
// страница в выдаче была бы пустой.
//
// Отсюда и JSON вместо словаря в translations.ts: тот собирается Vite и на
// сервере недоступен, а заводить второй источник истины по тексту, который
// должен совпадать с точностью до буквы, — верный способ их развести.
import pages from '../../content/pages.json';
import type { Lang } from '../i18n';

/** Раздел «О сервисе»: заголовок и абзацы под ним. */
export interface ContentSection {
  h: string;
  p: string[];
}

export interface ContentStep {
  h: string;
  p: string;
}

export interface ContentFaq {
  q: string;
  a: string;
}

/** Общее у всех страниц: заголовок, мета-описание и обещание под заголовком. */
interface PageHead {
  title: string;
  description: string;
  lead: string;
}

export interface AboutContent extends PageHead {
  sections: ContentSection[];
}

export interface HowContent extends PageHead {
  stepsTitle: string;
  steps: ContentStep[];
  faqTitle: string;
  faq: ContentFaq[];
  cta: string;
}

export interface TemplateContent extends PageHead {
  includes: string[];
  /** Чего в шаблоне нет, но обычно нужно. */
  add: string;
}

export interface TemplatesContent extends PageHead {
  listTitle: string;
  includesTitle: string;
  addTitle: string;
  cta: string;
  ctaNote: string;
  backToList: string;
  items: Record<string, TemplateContent>;
}

export interface PageContent {
  /** Подписи ссылок на экраны, у которых своего текста здесь нет. */
  nav: { home: string; pricing: string };
  about: AboutContent;
  how: HowContent;
  templates: TemplatesContent;
}

const CONTENT = pages as unknown as Record<Lang, PageContent>;

/** Тексты на языке читателя. Незнакомый язык — английский, как и везде. */
export function pageContent(lang: Lang): PageContent {
  return CONTENT[lang] ?? CONTENT.en;
}
